import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SketchPicker } from "react-color";
import { debounce } from "lodash";
import { Tooltip } from "../../../../../revvComponents";

// Internal Imports
import { DOCUMENTS, IMAGE_URLS } from "../../../../../constants";

// Action Imports
import { preventEditorToDeactivate } from "../../../../../actions/DocumentActions/index";

// Destructuring
const { FONT_COLORS } = DOCUMENTS;
const { TableBorder } = IMAGE_URLS;

class ColorOptionBtns extends Component {
  state = {
    bgColorSelected: "#fff",
    borderColorSelected: "#fff",
  };

  stylingDropDownRef = React.createRef();

  componentDidMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _colorOnChangeDebounce = debounce(
    event => {
      if (this.props.showBackgroundColorDropdown) {
        this.props.applyBackgroundColor(event);
      }
      if (this.props.showBorderColorDropdown) {
        this.props.applyBorderColor(event);
      }
    },
    500,
    { leading: true, trailing: false },
  );

  _onColorChange = event => {
    if (this.props.showBackgroundColorDropdown) {
      this.setState({
        bgColorSelected: event.hex,
        borderColorSelected: "#fff",
      });
    }
    if (this.props.showBorderColorDropdown) {
      this.setState({
        borderColorSelected: event.hex,
        bgColorSelected: "#fff",
      });
    }
    this._colorOnChangeDebounce(event);
  };

  _handleClick = e => {
    if (
      this.node &&
      !this.node.contains(e.target) &&
      (this.props.activeToolbarDropDown === "BACKGROUND_COLOR" ||
        this.props.activeToolbarDropDown === "BORDER_COLOR")
    ) {
      this.props.toogleToolbarDropDown(null);
    }

    if (
      this.node &&
      this.node.contains(e.target) &&
      (this.props.activeToolbarDropDown === "BACKGROUND_COLOR" ||
        this.props.activeToolbarDropDown === "BORDER_COLOR")
    ) {
      // prevent loosing editor focus when style/weight is selected
      e.preventDefault();
    }
  };

  // We will not use this method when batch update api for header is available
  _handleDisableBGColor = () => {
    const { component, tableSelectionType, cellSelection } = this.props;
    const {
      data: {
        attributes: { dataSource, isUnlinkedTableDocument, rowCount },
      },
    } = component;
    if (
      dataSource === "TableApi" &&
      !isUnlinkedTableDocument &&
      tableSelectionType
    ) {
      const { type, spanID } = tableSelectionType;
      // for row selection
      if (type === "ROW" && spanID === 0) {
        return true;
      }
      // for column selection when only header row
      if (type === "COLUMN" && rowCount === 1) {
        return true;
      }
    }
    if (
      dataSource === "TableApi" &&
      !isUnlinkedTableDocument &&
      cellSelection
    ) {
      // for cell selections in header row
      if (cellSelection && cellSelection.rows[0] === 0) {
        return true;
      }
      return false;
    }
    return false;
  };

  render() {
    let colorSelected;
    if (this.props.showBackgroundColorDropdown) {
      colorSelected = this.state.bgColorSelected;
    } else if (this.props.showBorderColorDropdown) {
      colorSelected = this.state.borderColorSelected;
    }

    if (!this.props.readOnly) {
      return (
        <div
          className="table-add-column styling-icons coloroptionbtns-wrapper"
          ref={ele => {
            this.node = ele;
          }}>
          <Fragment>
            <div
              ref={this.stylingDropDownRef}
              className="table-style-items disabled"
              role="button"
              tabIndex={0}
              disabled>
              {!this._handleDisableBGColor() && (
                <Tooltip
                  placement="bottom"
                  overlay="Background Color"
                  align={{
                    offset: [0, 3],
                  }}>
                  <span
                    data-test="table-background-color-span"
                    className={`revvtabletoolbar-btn btn-positive ${
                      this.props.showBackgroundColorDropdown
                        ? "is-color-active"
                        : ""
                    }`}
                    onMouseDown={e => {
                      this.props.toggleDropdown(e, "BackgroundColor");
                    }}
                    role="button"
                    tabIndex={0}>
                    <i>
                      <FontAwesomeIcon
                        icon={["far", "fill-drip"]}
                        color="#586986"
                      />
                    </i>
                  </span>
                </Tooltip>
              )}

              <Tooltip
                placement="bottom"
                overlay="Border Color"
                align={{
                  offset: [0, 3],
                }}>
                <span
                  data-test="table-border-color-span"
                  className={`revvtabletoolbar-btn btn-positive ${
                    this.props.showBorderColorDropdown ? "is-color-active" : ""
                  }`}
                  onMouseDown={e => {
                    this.props.toggleDropdown(e, "BorderColor");
                  }}
                  role="button"
                  tabIndex={0}>
                  <img className="" src={TableBorder} alt="Border Color" />
                </span>
              </Tooltip>
            </div>
            {(this.props.showBackgroundColorDropdown ||
              this.props.showBorderColorDropdown) && (
              <div className="table-customcolor-dropdown-wrapper">
                <SketchPicker
                  color={colorSelected}
                  onChange={event => this._onColorChange(event)}
                  presetColors={FONT_COLORS}
                  width={225}
                  disableAlpha
                  data-test="table-color-option-picker"
                />
              </div>
            )}
          </Fragment>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta, tableSelectionType } = state.DocumentStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId, cellSelection } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined &&
    focusRowID !== null &&
    focusColumnID !== undefined &&
    focusColumnID !== null
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
    tableSelectionType,
    cellSelection,
  };
};

const mapDispatchToProps = {
  preventEditorToDeactivate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorOptionBtns);
